// @flow
import React, { Component } from 'react'
import _ from 'lodash'
import styled, { type StyledComponent } from 'styled-components'
import type { GroupedArrayParameters, OptionType } from '../types'
import LocationsSelect from './LocationsSelect'
import LabeledWrapper from './LabeledWrapper'
import Button from '../controls/PrimaryButton'
import type { Location } from './LocationsSelect'
import AddParametersGroupBlock from './AddParametersGroupBlock'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  padding-top: 10px;
`

type Props = {|
  ajaxUrl: string,
  ajaxDelay: number,
  labelTitle: string,
  quickLocationOptions: Array<OptionType>,
  dropdownLocationOptions: Array<OptionType>,
  includedLocationGroups: Array<GroupedArrayParameters>,
  errors: Array<string>,
  preloadedLocations: Array<Location>,
  allowAdding: boolean,
  onChange: Function,
  onLocationsLoad: Function,
  onIncludedLocationGroupAdd: Function,
  onIncludedLocationGroupRemove: Function
|}

const t = {
  add: 'Добавить группу'
}

export default class IncludedLocationsSelect extends Component<Props> {
  render() {
    return (
      <LabeledWrapper label={this.props.labelTitle} twoLines>
        {_.map(this.props.includedLocationGroups, (group, index: number) => {
          return (
            <Wrapper key={index}>
              <LocationsSelect
                errors={this.props.errors}
                quickLocationOptions={this.props.quickLocationOptions}
                dropdownLocationOptions={this.props.dropdownLocationOptions}
                locationIds={group.value}
                preloadedLocations={this.props.preloadedLocations}
                ajaxUrl={this.props.ajaxUrl}
                ajaxDelay={this.props.ajaxDelay}
                locationType="included"
                className={`t-IncludedLocationsSelect_${index}`}
                onLocationsLoad={(locations) => this.props.onLocationsLoad(locations)}
                onChange={(newIds) => {
                  const newIncludedLocationGroups = _.cloneDeep(this.props.includedLocationGroups)
                  newIncludedLocationGroups[index].value = newIds
                  this.props.onChange(newIncludedLocationGroups)
                }}
              />
              {this.props.includedLocationGroups.length > 1 && (
                <AddParametersGroupBlock
                  index={index}
                  groups={this.props.includedLocationGroups}
                  currentGroup={group}
                  inputName={`audience_location_group_name_${index}`}
                  inputValue={group.name}
                  onChange={(groups) => this.props.onChange(groups)}
                  onGroupRemove={(groups) => this.props.onIncludedLocationGroupRemove(groups)}
                />
              )}
            </Wrapper>
          )
        })}
        {this.props.allowAdding && (
          <Wrapper>
            <Button
              className="t-IncludedLocationsGroupAddButton"
              small
              onClick={() => {
                this.props.onChange(
                  _.concat(this.props.includedLocationGroups, { value: [], name: '' })
                )
                this.props.onIncludedLocationGroupAdd()
              }}
            >
              {t.add}
            </Button>
          </Wrapper>
        )}
      </LabeledWrapper>
    )
  }
}
